export default function ViewMessages() {
    console.log("in ViewMessage.js");
}